import Announcement from '@/components/common/Announcement/Announcement'
import { Link } from '@/components/common/Announcement/components'
import { SUPPORT_URL } from '@/config/settings'
import { Button } from '@/components/common/Button'

interface FallbackErrorProps {
  resetErrorBoundary: () => void
}

export const FallbackError = ({ resetErrorBoundary }: FallbackErrorProps) => {
  return (
    <Announcement subTitle={'Sorry, Something went wrong!'}>
      <Button
        primary
        onClick={() => resetErrorBoundary()}
      >
        {'Retry'}
      </Button>
      <Link
        href={SUPPORT_URL}
      >
        {'Get help'}
      </Link>
    </Announcement>
  )
}
